import React, {useEffect, useState} from 'react'
import {useAuth} from '../context/AuthContext'
import apiClient from '../api/apiClient'
import './StaffPage.css'
import './TeacherDownloadPage.css'

function TestGroupListEntry({ group, onDownload }) {
    const files = Array.isArray(group.examupload_filenames) ? group.examupload_filenames : []

    return (
        <li className="td-group-item">
            <p className="td-group-title">{group.navn}</p>
            <ul className="td-meta-lines" aria-label="Oplysninger om prøvegruppen">
                <li>
                    <span className="td-meta-label">Sprogcenter</span>
                    <span className="td-meta-value">{group.sprogcenter_navn || '—'}</span>
                </li>
                <li>
                    <span className="td-meta-label">Eksaminator</span>
                    <span className="td-meta-value">{group.eksaminator_navn || '—'}</span>
                </li>
                <li>
                    <span className="td-meta-label">Censor</span>
                    <span className="td-meta-value">{group.censor_navn || '—'}</span>
                </li>
            </ul>
            {files.length === 0 ? (
                <p className="td-empty-files">Ingen filer til download i denne prøvegruppe endnu.</p>
            ) : (
                <ul className="td-file-list" aria-label="Filer til download">
                    {files.map((fileName) => (
                        <li key={`${group.id}-${fileName}`} className="td-file-row">
                            <span className="td-file-name" title={fileName}>{fileName}</span>
                            <button
                                type="button"
                                className="td-download-btn"
                                onClick={() => onDownload(fileName)}
                            >
                                Download
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    )
}

export default function TeacherDownloadPage(){
    const {user} = useAuth()
    const user_id = user.id;
    const sprogcenter_id = user.scId;

    const [censorId, setCensorId] = useState(null)
    const [examinatorTestGroupList, setExaminatorTestGroupList] = useState([])
    const [censorTestGroupList, setCensorTestGroupList] = useState([])

    async function getCensorId(){
        try{
            const result = await apiClient.get('/api/teacher/getcensorid', {
                params: {userId: user_id, sprogcenterId: sprogcenter_id}
            })
            const {censor_id} = result.data    
            console.log (`censor id fundet til ${censor_id} for ${user_id}`)
            setCensorId(censor_id)
        }catch(e){
            console.log("fejl ved FE hentning af censorid")
            console.log(e)
        }
    }


    async function getName(censor_id){
        if(!censor_id) return 'Navn uafklaret'
        try {
            const result = await apiClient.get('/api/testgroup/getcensorname', {
                params: {censor_id}
            })
            const d = result?.data
            if(!d || (!d.fornavn && !d.efternavn)) return 'Navn uafklaret'
            return `${d.fornavn || ''} ${d.efternavn || ''}`.trim()
        } catch(e) {
            console.log("fejl ved getName", e)
            return 'Navn uafklaret'
        }
    }

    async function fetchTestGroups(){
        console.log("starting fecth with " + censorId)

        try{
            const result = await apiClient.get('/api/testgroup/allteachersgroups', 
                { params : {teacherID: user_id, sprogcenterID: sprogcenter_id} }
            )           

            if(result?.data){
                const dataWithExaminatorNames = await Promise.all(
                    result.data.map(async (pg) => {
                        const teacherName = await getName(pg.underviser_id)
                        const censorName = await getName(pg.censor_id)
                        return {
                            ...pg,
                            eksaminator_navn: teacherName,
                            censor_navn: censorName,
                        }
                    })
                )
                setExaminatorTestGroupList(dataWithExaminatorNames)
            }
        }catch(e){
            console.log("fejl ved alle pg til eksaminator")
            console.log(e)
        }

        try{
            const result = await apiClient.get('/api/testgroup/allassessorsgroups', 
                { params : {assessorID: user_id, sprogcenterID: sprogcenter_id} }
            )
            if(result?.data){
                const dataWithExaminatorNames = await Promise.all(
                    result.data.map(async (pg) =>{
                        const teacherName = await getName(pg.underviser_id)
                        const censorName = await getName(pg.censor_id)
                        return{
                            ...pg, 
                            eksaminator_navn: teacherName, 
                            censor_navn: censorName,
                        }
                    })
                )
                setCensorTestGroupList(dataWithExaminatorNames)
            }
        }catch(e){
            console.log("fejl ved alle pg til censor")
            console.log(e)
        }
    }

    useEffect( ()=>{
         getCensorId()
    }, [])

    useEffect( ()=>{
        if(censorId) fetchTestGroups()
    }, [censorId])

    async function handleDownload(filename){
        try{
            const res = await apiClient.get('/api/downloadfile', {
                params: {filename},
                responseType: 'blob'
            })
            const url = window.URL.createObjectURL(res.data)
            const a = document.createElement('a')
            a.href = url
            a.download = filename
            a.click()
            window.URL.revokeObjectURL(url)
        }catch(e){
            console.log("fejl ved download af fil")
            console.log(e)
        }
    }
    const no_go_sc_id = [2, 25, 42, 43, 53, 70, 74, 75, 83]

    return(
        <div className="teacher-download-page">
            <div className="table-card td-main-card">
                <section className="td-role-block" aria-labelledby="td-heading-examinator">
                    <h2 id="td-heading-examinator" className="td-role-heading">
                        Som eksaminator
                    </h2>
                    {no_go_sc_id.includes(sprogcenter_id) ? (
                        <p>Kontakt dit sprogcenters administration for prøver</p>
                    ) : examinatorTestGroupList.length === 0 ? (
                        <p className="td-empty-section">Ingen prøvegrupper med filer i denne rolle.</p>
                    ) : (
                        <ul className="td-group-list">
                            {examinatorTestGroupList.map((eTG) => (
                                <TestGroupListEntry
                                    key={eTG.id}
                                    group={eTG}
                                    onDownload={handleDownload}
                                />
                            ))}
                        </ul>
                    )}
                </section>

                <section className="td-role-block" aria-labelledby="td-heading-censor">
                    <h2 id="td-heading-censor" className="td-role-heading">
                        Som censor
                    </h2>
                    {no_go_sc_id.includes(sprogcenter_id) ? (
                        <p>Kontakt dit sprogcenters administration for prøver</p>
                    ) : censorTestGroupList.length === 0 ? (
                        <p className="td-empty-section">Ingen prøvegrupper med filer i denne rolle.</p>
                    ) : (
                        <ul className="td-group-list">
                            {censorTestGroupList.map((cTG) => (
                                <TestGroupListEntry
                                    key={cTG.id}
                                    group={cTG}
                                    onDownload={handleDownload}
                                />
                            ))}
                        </ul>
                    )}
                </section>
            </div>
        </div>
    )
}
